module.exports = __webpack_public_path__ + "img/Group8293@2x.2c5de2e4.png";